import React from "react";

const AppointmentOption = ({ availableOption, setTreatments }) => {
  const { name, slots, price } = availableOption;
  return (
    <div className="m-5 md:m-0 p-10 flex flex-col items-center gap-4 shadow rounded-md">
      <p className=" text-teal-500 text-center text-xl font-medium">{name}</p>
      <p className="font-medium">
        {slots.length ? slots[0] : "Try another day"}
      </p>
      <p>{slots.length} SPACES AVAILABLE</p>
      <p>
        <small>${price}</small>
      </p>
      <label
        htmlFor="appointmentOptionModal"
        className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white"
        disabled={!slots.length}
        onClick={() => setTreatments(availableOption)}
      >
        Book Appointment
      </label>
    </div>
  );
};

export default AppointmentOption;
